import axios, { AxiosResponse } from 'axios';
import { attachmentsApi } from 'constants/api';
import { AttachmentEntityType } from 'store/apiClients/events/types';
import { AttachmentAccessTypes } from 'common/attachments/enums';


export class AttachmentsService {
  createFile = async (data: FormData, isSystem: boolean, accessTypes: AttachmentAccessTypes[]): Promise<AxiosResponse<AttachmentEntityType>> => {
      const params = new URLSearchParams();

      params.append('isSystem', `${isSystem}`);
      accessTypes.forEach((type) => params.append('readAccessTypes', type));

      return axios.post(`${attachmentsApi}/attach`, data, { params });
  };

  createLink = async (link: string): Promise<AxiosResponse<AttachmentEntityType>> => (
    axios.post(`${attachmentsApi}/attachLink`, null, { params: { link } })
  );

  deleteById = async (id: number): Promise<AxiosResponse> => (
    axios.delete(`${attachmentsApi}/delete`, {
      params: {
        attachmentIds: id,
      },
    })
  );
}
